// =============================================================================
// Premium Profile Wizard — option catalogs
// Centralised here so individual step components stay small and declarative.
// =============================================================================

export const WIZARD_STEPS = [
  { k: "basic",        label: "Basic" },
  { k: "appearance",   label: "Appearance" },
  { k: "gallery",      label: "Gallery" },
  { k: "about",        label: "About" },
  { k: "services",     label: "Services" },
  { k: "pricing",      label: "Pricing" },
  { k: "schedule",     label: "Schedule" },
  { k: "contact",      label: "Contact" },
  { k: "verification", label: "Verify" },
  { k: "preview",      label: "Preview" },
];

export const CURRENCIES = ["EUR", "USD", "GBP", "CHF", "AED"];

export const LANGUAGES = [
  "English", "Russian", "Montenegrin", "Serbian", "Croatian",
  "Italian", "French", "Spanish", "German", "Greek", "Turkish", "Arabic",
];

export const AVAILABILITY_STATUS = [
  { v: "available_now", label: "Available now" },
  { v: "available_today", label: "Available today" },
  { v: "by_appointment", label: "By appointment" },
  { v: "vacation",       label: "On vacation" },
];

export const FITNESS_LEVELS = ["Light", "Active", "Fit", "Athletic", "Toned"];
export const DRESS_SIZES = ["XS", "S", "M", "L", "XL"];

export const PERSONALITY_TAGS = [
  "Elegant", "Playful", "Sophisticated", "Adventurous", "Charming",
  "Mysterious", "Confident", "Romantic", "Witty", "Refined",
];

export const INTEREST_TAGS = [
  "Fine dining", "Travel", "Wine", "Art", "Music", "Cinema",
  "Theatre", "Fashion", "Yoga", "Fitness", "Reading", "Languages",
  "Photography", "Nightlife", "Dancing", "Beach", "Skiing", "Sailing",
];

export const HOBBY_TAGS = [
  "Cooking", "Hiking", "Painting", "Tennis", "Pilates", "Surfing",
  "Horse riding", "Cycling", "Diving", "Skiing",
];

export const ACTIVITY_TAGS = [
  "Dinner dates", "City tours", "Beach days", "Wine tasting",
  "Gallery openings", "Concerts", "Yacht trips", "Weekend getaways",
];

// =============================================================================
// SERVICE MATRIX
// =============================================================================
export const SERVICE_CATEGORIES = [
  {
    k: "companion",
    label: "Companion",
    items: [
      { k: "dinner",       label: "Dinner companion" },
      { k: "event",        label: "Event companion" },
      { k: "travel",       label: "Travel companion" },
      { k: "business",     label: "Business meeting" },
      { k: "city_tour",    label: "City tour" },
      { k: "social",       label: "Social gathering" },
      { k: "overnight",    label: "Overnight companion" },
    ],
  },
  {
    k: "wellness",
    label: "Wellness",
    items: [
      { k: "relaxation", label: "Relaxation" },
      { k: "massage",    label: "Massage" },
      { k: "spa",        label: "Spa companion" },
    ],
  },
  {
    k: "extras",
    label: "Extras",
    items: [
      { k: "custom",     label: "Custom requests" },
      { k: "photo",      label: "Photography session" },
      { k: "travel_arr", label: "Travel arrangements" },
    ],
  },
];

export const SERVICE_STATUSES = [
  { v: "available",     label: "Available" },
  { v: "not_available", label: "Not available" },
  { v: "included",      label: "Included" },
  { v: "extra",         label: "Extra fee" },
];

// =============================================================================
// PRICING & SCHEDULE
// =============================================================================
export const DURATION_KEYS = [
  { k: "1h",  label: "1 hour" },
  { k: "2h",  label: "2 hours" },
  { k: "3h",  label: "3 hours" },
  { k: "6h",  label: "6 hours" },
  { k: "12h", label: "12 hours" },
  { k: "overnight", label: "Overnight" },
  { k: "weekend",   label: "Weekend" },
];

export const PRICING_MODES = [
  { v: "incall",  label: "Incall" },
  { v: "outcall", label: "Outcall" },
  { v: "travel",  label: "Travel" },
];

export const WEEK_DAYS = [
  { k: "mon", label: "Monday" },
  { k: "tue", label: "Tuesday" },
  { k: "wed", label: "Wednesday" },
  { k: "thu", label: "Thursday" },
  { k: "fri", label: "Friday" },
  { k: "sat", label: "Saturday" },
  { k: "sun", label: "Sunday" },
];

// =============================================================================
// CONTACT
// =============================================================================
export const COUNTRY_CODES = [
  { code: "+382", label: "Montenegro" },
  { code: "+48",  label: "Poland" },
  { code: "+49",  label: "Germany" },
  { code: "+43",  label: "Austria" },
  { code: "+41",  label: "Switzerland" },
  { code: "+381", label: "Serbia" },
  { code: "+385", label: "Croatia" },
  { code: "+39",  label: "Italy" },
  { code: "+33",  label: "France" },
  { code: "+34",  label: "Spain" },
  { code: "+44",  label: "United Kingdom" },
  { code: "+1",   label: "USA / Canada" },
];

export const CONTACT_CHANNELS = [
  { k: "phone",    label: "Phone" },
  { k: "whatsapp", label: "WhatsApp" },
  { k: "telegram", label: "Telegram" },
  { k: "viber",    label: "Viber" },
  { k: "email",    label: "Email" },
  { k: "in_app",   label: "In-app message" },
];

export const RESPONSE_TIMES = [
  { v: "under_15m", label: "Within 15 minutes" },
  { v: "under_1h",  label: "Within 1 hour" },
  { v: "same_day",  label: "Same day" },
  { v: "next_day",  label: "Next day" },
];

export const CONTACT_VISIBILITY = [
  { v: "public",          label: "Public" },
  { v: "verified_only",   label: "Verified clients only" },
  { v: "after_request",   label: "After contact request" },
];

export const PHOTO_MIN = 3;
export const PHOTO_MAX = 20;
